'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadFile = undefined;

var _reduxApiMiddleware = require('redux-api-middleware');

var _actionTypes = require('../constants/actionTypes');

var types = _interopRequireWildcard(_actionTypes);

var _api = require('../utils/api');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var downloadFile = exports.downloadFile = function downloadFile(endpoint) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  return function (dispatch) {
    dispatch(_defineProperty({}, _reduxApiMiddleware.CALL_API, {
      endpoint: endpoint,
      method: method,
      types: [{
        type: types.DOWNLOAD_REQUEST
      }, {
        type: types.DOWNLOAD_SUCCESS,
        payload: function payload(action, currentState, res) {
          return (0, _api.sendFileToBrowser)(res);
        }
      }, types.DOWNLOAD_FAILURE]
    }));
  };
};